import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiHelperService } from 'projects/apna-lib/src/lib/services/api-helper.service';
import { UserIdentityService } from 'projects/apna-lib/src/lib/services/user-identity.service';

@Component({
  selector: 'fa-student-applications',
  templateUrl: './student-applications.component.html',
  styleUrls: ['./student-applications.component.scss']
})
export class StudentApplicationsComponent implements OnInit {

   
  @Input() active: number =  2;
  userDetails: any;
  @Input() applicantId: any;
  @Input() studentId: any;
  @Input() admissionData: any;
  @Input() applicantData: any;

  constructor(
    private apiHelper: ApiHelperService,
    private userIdentity: UserIdentityService,
    private activatedRoute: ActivatedRoute
  ){
    this.userDetails = this.userIdentity?.getUserDetails()
    
  }

  ngOnInit(): void {
  }


}
